<template>
  <div>
    <div>{{RoadiuItem.name}}</div>
    <el-radio-group v-model="value" class="radio_box">
        <el-radio class="radio_item" label="全公司" value="1"></el-radio>
        <el-radio class="radio_item" label="个人" value="2"></el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
    props:{
        Authority:{
          type:Array,
        },
        RoadiuItem:{
            type:Object,
        }
    },
    data(){
        return{
            value:""
        }
    },
    mounted(){
      console.log(this.Authority,'this.Authority---->55555')
     if(this.Authority && this.Authority.length>0){
        this.Authority.forEach(item => {
          if(item.id==this.RoadiuItem.id){
            this.value=item.option=='1'?'全公司':'个人'
          }
        })
      }
    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
.radio_box{
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    line-height: 56px;
    .radio_item{
        padding-right: 36px;
    }
}
</style>
